import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Router, ActivatedRoute } from '@angular/router';

import { ApiService, MessagesService } from '@angular/synthrone-design/services';
import { APP_CONFIG } from '@synthroneApp/app.config';
import { CountryServiceSDK } from 'ms-language-country-angular-sdk';

import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-countries-view',
  templateUrl: './countries-view.component.html',
  styleUrls: ['./countries-view.component.scss']
})
export class CountriesViewComponent {

  @ViewChild('countryTable') countryTable;

  configColumns = {
      name: {
          label: 'Name',
          sortable: false,
          truncate: true
      },
      isoAlpha2Code: {
          label: 'ISO Alpha 2 Code',
          sortable: false,
          truncate: true
      },
      isoAlpha3Code: {
        label: 'ISO Alpha 3 Code',
        sortable: false,
        truncate: true
      },
      isoNumericCode: {
        label: 'ISO Numeric Code',
        sortable: false,
        truncate: true
      }
  };
  countries = [];

  constructor(
    public countryService: CountryServiceSDK,
    private _router: Router,
    private route: ActivatedRoute,
    private messagesService: MessagesService,
    protected api: ApiService,
    @Inject(APP_CONFIG) private config,
    protected dialog: MatDialog
  ) {}

  ngOnInit() {
    this.getCountries().then(() => {
      this.route.queryParams.subscribe(() => { this.refreshTable() });
    })
  }

  refreshTable = () => {
      this.countryTable.getData()
  }

  breadcrumbsFN = () => {
    return Observable.of([
      {
        breadcrumb: 'ADMINER',
        url: '/'
      },
      {
        breadcrumb: 'Manage Countries',
        url: '/countries'
      }
    ]);
  };

  sdCountries = (limit: any, offset: any) => {
    return Observable.of(this.countries);
  };

  getCountries(): Promise<void> {
    return new Promise<void>((resolve) => {
      this.api.makeSDKRequest(this.countryService, 'countryGet', false)
        .subscribe((results: any[]) => {
          this.countries = results;
          resolve();
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/components/views/countries-view/countries-view.component.ts